import React from "react";
import PropTypes from "prop-types";
import ResumeItem from "./ResumeItem";
import "./ResumeSection.css";  // Make sure to create this CSS file for styling

const ResumeSection = ({ data, title }) => {
  const resumeData = data || [];

  return (
    <div className="resume-section">
      <h2>{title}</h2>
      <div className="timeline">
        {resumeData.length > 0 ? (
          resumeData.map((item, index) => (
            <ResumeItem
              key={index}
              title={item.title}
              timeline={item.timeline}
              place={item.place}
              description={item.description}
              skills={item.skills}
            />
          ))
        ) : (
          <p>No data available</p>
        )}
      </div>
    </div>
  );
};

ResumeSection.propTypes = {
  data: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
};

export default ResumeSection;
